
jQuery(document).ready(function() {


        // REFERENCE PAGE EXPAND CONTENT
        var $showMoreRefsBtn = jQuery('#show-more-refs');
        var refCard = jQuery('#customer-references-page > .outerwrap > .grid-x > .ref-cards').length;

        jQuery('#customer-references-page > .outerwrap > .grid-x > .ref-cards:gt(2)').hide();    
                
            if (refCard > 3) {
                jQuery($showMoreRefsBtn).show();
            } else {
                jQuery($showMoreRefsBtn).hide();
            }
        

        jQuery($showMoreRefsBtn).click(function () {
            jQuery('#customer-references-page > .outerwrap > .grid-x > .ref-cards:gt(2)').toggle('slide');
            jQuery($showMoreRefsBtn).toggleClass('expanded-content');

                if ($showMoreRefsBtn.hasClass("expanded-content")) {
                    $showMoreRefsBtn.html("Vis færre referanser");
                } else {
                    $showMoreRefsBtn.html("Vis flere referanser");
                }
        });

}); 